module.exports = __webpack_public_path__ + "img/sensor_0.86541999.png";